import { DOCUMENT_ERROR_SOURCE } from 'shared/domain/document/documentError';
import { DocumentUrlsModel } from './documentUrlsModel';

const CONVERSION_URL_KEYS: (keyof DocumentUrlsModel)[] = [
  'thumbnailSignedRequest',
  'drawingSignedRequest',
  'mergedSignedRequest',
  'mergedThumbnailSignedRequest',
  'imageSignedRequest',
];

function isUsableSignedUrl(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.length > 0 &&
    value !== DOCUMENT_ERROR_SOURCE
  );
}

/**
 * Merges fresh getSources payload into existing signed URLs.
 * Conversion URLs are preserved when refresh returns only the base PDF URL.
 */
export function mergeDocumentUrlsModel(
  previous: DocumentUrlsModel | undefined,
  incoming: DocumentUrlsModel
): DocumentUrlsModel {
  const merged: DocumentUrlsModel = {
    ...(previous || {}),
    ...incoming,
  };

  if (isUsableSignedUrl(incoming.signedRequest)) {
    merged.signedRequest = incoming.signedRequest;
  }

  CONVERSION_URL_KEYS.forEach((key) => {
    if (!isUsableSignedUrl(incoming[key]) && isUsableSignedUrl(previous?.[key])) {
      merged[key] = previous![key];
    }
  });

  return merged;
}
